<template>
  <!-- <div class="groupDivide"> -->
	<!--
	<ul class="groupItem featureList">
		<li class="featureItem" v-for="(feature, index) in list" :feature="feature" :index="index">{{feature}}</li>
	</ul>
	-->
	<div class="groupItem featureList">
		<EventNotification :feature="textFeature" :index="20" class="featureItem" />
		<FeatureItem class="featureItem" v-for="(feature, index) in list" :key="index" :feature="feature" :index="index">{{feature}}</FeatureItem>
	</div>
	<!-- <div class="groupItem noteWindow">
		<h4 class="noteTitle">EVENT NOTIFICATION WINDOW</h4>
		<notifications group="events" position="top center"/>
	</div> -->
  <!-- </div> -->
</template>


<script>
import FeatureItem from './FeatureItem.vue'
import EventNotification from './EventNotification.vue';

export default {
  name: 'eventOnSite',
  components: {
		FeatureItem,
		EventNotification
  },
  data() { return  {
		textFeature: 		  { 'title' : 'Text Opt-In / Communications',  'img': 'atEvent.jpeg',
		  'blurb' : 'Announce a surprise speaker or contact a single attendee with inbound/outbound text and email communication support.'},
	  list: [
		  { 'title' : 'Automated Check-in / Badge Printing',  'img': 'DigitalSolutions.jpg',
		  'blurb' :  'Streamline event entry and collect detailed and secure attendance metrics with automated check-in and badge printing software.' },
		  { 'title' : 'Digital Waivers',  'img': 'CreativeServices.jpg',
		  'blurb' : 'Collect hassle free legal records and allow attendee participation with secure digital waivers.'},
		  { 'title' : 'Program / Agenda Updates Mobile App',  'img': 'afterEvent.jpeg',
		  'blurb' : 'Help attendees navigate your event with a custom mobile application allowing easy event information access, personal information updates, and helpful feedback.'},
		  { 'title' : 'Attendance Tracking for CEU',  'img': 'ProductCultureTraining.jpg',
		  'blurb' : 'Reward your attendees for their participation with comprehensive attendance tracking and downstream credit system integration.'},
	  ],
	  next: 0,
	  updateNoteFunc: null
    }
  }
}
</script>
<style lang='scss' scoped>
.groupDivide {
	display: flex;
    flex-direction: row;
	flex-wrap: wrap;
}
.groupItem {
	width: 100%;
	// width: 50%;
	// margin: 1%;
}
.noteWindow {
	border: solid 1px $darkblue;
	background-color: $darkblue;
}
.featureList {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
			justify-content: center;
}
.featureItem {
	max-width: 350px;
}
.notifications {
	display: block;
	position: relative;
}
.noteTitle {
	color: white;
}
</style>